import type { CsvImportResponse, ImportDataSourcePrefill } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { fileImportApiHttp } from '../../_shared/infrastructure/file-import-api.http';
import type { FileImportGateway } from './file-import.gateway';

/**
 * Real implementation over the shared api client. Parse/analyze come from the
 * shared `fileImportApiHttp`; this is the single place that knows the
 * immediate-import endpoint (request shape kept 1:1 with the original
 * FileImportStepper).
 */
export const httpFileImportGateway: FileImportGateway = {
  importRows: (request) => api.post<CsvImportResponse>('/csv/import', request),
  // `getRaw`: `get` unwraps `{ data: null }` into the envelope itself.
  fetchImportDataSource: async () =>
    (await api.getRaw<ImportDataSourcePrefill>('/lists/import-data-source')).data ?? null,

  // ── Parse/analyze read layer (shared with the list wizards) ──
  ...fileImportApiHttp,
};
